import React, { Fragment, useRef, useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import { useHistory } from "react-router-dom"
import {
  BottomNavigation,
  BottomNavigationAction,
  Fab,
  Tooltip
} from "@material-ui/core"
import { withStyles } from "@material-ui/core/styles"
import styles from "./styles"
import StarIcon from "@material-ui/icons/Star"
import DoubleCheck from "components/Icons/DoubleCheck"
import HomeIcon from "@material-ui/icons/Home"
import AddIcon from "@material-ui/icons/Add"
import { receiveUpload } from "actions/upload"
import { setIsLoading } from "actions/isLoading"
// import Loading from "components/Loading"
import clsx from "clsx"

const BottomNav = ({ classes }) => {
  const dispatch = useDispatch()
  // const isLoading = useSelector(state => state.isLoading.loading)
  const canPost = useSelector(state => state.organization.currentOrg.can_post)
  const history = useHistory()
  const fileInput = useRef(null)
  const [navigationHeight, setNavigationHeight] = useState(80)

  const handleAdd = () => {
    fileInput.current.click()
  }

  const handleUpload = () => {
    const file = fileInput.current.files[0]
    const isVideo = file.type.indexOf("video/") > -1
    if (file !== undefined) {
      dispatch(setIsLoading(true))
      dispatch(receiveUpload(file, isVideo ? "video" : "image"))
      history.push("/app/create")
    }
  }

  const handleClick = route => {
    history.push(`/app/${route}`)
  }

  useEffect(() => {
    var elementHeight = document.querySelector("#buttonNavegation").offsetHeight
    if (elementHeight <= 80) {
      setNavigationHeight("100px")
    } else {
      setNavigationHeight(`${elementHeight - 80 + 100}px`)
    }
  }, [])

  return (
    <Fragment>
      <BottomNavigation className={classes.root} id="buttonNavegation">
        <Tooltip title="My Org">
          <BottomNavigationAction
            onClick={() => handleClick("feed")}
            value="feed"
            icon={<HomeIcon className={classes.homeIcon} />}
          />
        </Tooltip>
        <Tooltip title="My Submitted">
          <BottomNavigationAction
            onClick={() => handleClick("submitted")}
            value="submitted"
            icon={<StarIcon className={classes.starIcon} />}
          />
        </Tooltip>
        <Tooltip title="My Published">
          <BottomNavigationAction
            onClick={() => handleClick("published")}
            value="published"
            icon={<DoubleCheck className={classes.checkIcon} />}
          />
        </Tooltip>
      </BottomNavigation>
      {/*eslint-disable */
      history.location.pathname === "/app/create" ||
      history.location.pathname === "/app/add-org" ? null : (
        <Tooltip title={!canPost ? "Create Post Disabled" : "Create Post"}>
          <div>
            <Fab
              style={{ bottom: `${navigationHeight}` }}
              color="primary"
              aria-label="add"
              onClick={handleAdd}
              className={classes.fabContainer}
              disabled={!canPost}
            >
              <AddIcon
                sytle={{ bottom: navigationHeight + "!important" }}
                className={clsx(
                  classes.addButton,
                  !canPost && classes.addButtonDisabled
                )}
              />
            </Fab>
          </div>
        </Tooltip>
      ) /*eslint-enable */}
      <input
        ref={fileInput}
        className={classes.file}
        type="file"
        id="file"
        name="file"
        accept="image/jpeg,image/jpg,image/png,application/pdf,image/x-eps,video/*"
        onChange={handleUpload}
      />
      {/* {isLoading && <Loading />} */}
    </Fragment>
  )
}

export default withStyles(styles)(BottomNav)



// WEBPACK FOOTER //
// ./src/components/BottomNav/index.jsx